/**
 * CL-PROPERTY-OS-002R3 — Defer portal Firestore reads while a pending invite remains in the URL.
 * Verified sessions must complete trusted invitation before CRM/profile/workspace reads.
 */

import { parseInviteCodeFromLocationSearch } from "./portalAuthErrors";
import { portalEmailVerificationSatisfiedFromUser } from "./portalEmailVerificationRolloutPolicy";

function safeStr(value) {
  return String(value ?? "").trim();
}

export function readPendingInviteCodeFromLocationSearch(search = "") {
  return parseInviteCodeFromLocationSearch(search);
}

/**
 * When true, layout and portal loaders must not read CRM/profile/project/workspace data.
 * Invite code in the URL is the source of truth until trusted completion clears it.
 */
export function shouldDeferPortalReadsForInviteInUrl(
  user = null,
  { pendingInviteCode = "", isCurrentSignupSession = false, pendingSignupContext = null } = {}
) {
  const code = safeStr(pendingInviteCode);
  if (!code) return false;
  if (!user || user.isAnonymous) return false;
  if (pendingSignupContext) return false;
  if (!portalEmailVerificationSatisfiedFromUser(user, { isCurrentSignupSession })) return false;
  return true;
}

/** Remove invite/code query params after confirmed trusted completion. */
export function buildLocationSearchWithoutInvite(search = "") {
  try {
    const params = new URLSearchParams(search);
    params.delete("invite");
    params.delete("code");
    const next = params.toString();
    return next ? `?${next}` : "";
  } catch {
    return "";
  }
}

export function buildClientPortalNavigateTargetPreservingSearch(pathname = "/client-portal", search = "") {
  const path = safeStr(pathname) || "/client-portal";
  const normalizedSearch = safeStr(search);
  return {
    pathname: path,
    search: normalizedSearch,
  };
}
